import type { JSX } from 'react'

import { TopNumber1SC } from './TopNumbers.styled'

export const Top1 = (): JSX.Element => (
  <TopNumber1SC
    width='128'
    height='188'
    viewBox='0 0 128 188'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M128 161.529V188H0V161.529H54.5085V35.6552L17.8983 52.9425H16.8136L10.5763 34.3046V33.2241L62.3729 0H83.7966V161.529H128Z'
      fill='url(#paint0_linear_5096_100016)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5096_100016'
        x1='-20.0678'
        y1='-0.236334'
        x2='166.674'
        y2='167.9'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#EFEFEF' stopOpacity='0.9' />
        <stop offset='1' stopColor='#7C7984' stopOpacity='0.2' />
      </linearGradient>
    </defs>
  </TopNumber1SC>
)
